import { useState } from 'react'

import parentStyles from '../styles.module.scss'
import AddAppDenyEntryModal from './AddAppDenyEntryModal'

import Button from '@/components/Button'
import { EnterpriseSettings, SettingType } from '@/types'

interface AppDenyListCardProps {
  settings: EnterpriseSettings
  isAdmin: boolean
  authoringEnabled?: boolean
}

const AppDenyListCard = ({ settings, isAdmin, authoringEnabled = true }: AppDenyListCardProps) => {
  const [modalOpen, setModalOpen] = useState(false)

  const entries = settings[SettingType.appDenyList] ?? []
  const label =
    entries.length > 0 ? `Blocked apps (${entries.length} app${entries.length === 1 ? '' : 's'})` : 'Blocked apps'

  return (
    <>
      <div className={parentStyles.settingsItem}>
        <div className={parentStyles.toggleLabel}>{label}</div>
        <Button
          title={entries.length > 0 ? 'Configure' : 'Add apps'}
          onClick={() => setModalOpen(true)}
          type="dark"
          className={parentStyles.controlButton}
          isDisabled={!isAdmin && entries.length === 0}
        />
      </div>

      <AddAppDenyEntryModal
        isOpen={modalOpen}
        close={() => setModalOpen(false)}
        currentList={entries}
        isAdmin={isAdmin}
        authoringEnabled={authoringEnabled}
      />
    </>
  )
}

export default AppDenyListCard
